<div *ngIf="vendorRequestData; else loading" class="wrapper has-padding">
  <!-- set focus when pressing skiplink button -->
  <div tabindex="-1" #vendorRequestElement class="bofa--skiplink">
  </div>
  <h2 class="bofa--heading is-5 is-stacked">Investigation Type: Contractor Ad Hoc</h2>
  <form [formGroup]="vendorRequestForm">

    <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space">
      <mat-card-content>
        <h3 class="bofa--heading is-5">Contractor Component Selection</h3>

        <div class = "flex-row-wrap">
          <mat-checkbox class="flexrow-padding" [disabled]="true" [checked]="true">
            <mat-label class = "whitespace-normal">Fingerprint</mat-label>
          </mat-checkbox>

          <mat-checkbox formControlName="componentsCheck" class="flexrow-padding" [disabled]="true">
            <mat-label class = "whitespace-normal">Actionbase</mat-label>
          </mat-checkbox>

          <mat-checkbox class="flexrow-padding" [disabled]="true" [checked]="true">
            <mat-label class = "whitespace-normal">Applicant Form</mat-label>
          </mat-checkbox>

          <mat-checkbox formControlName="lockboxCheck" class="flexrow-padding" [disabled]="true">
            <mat-label class = "whitespace-normal">Credit</mat-label>
          </mat-checkbox>

          <mat-checkbox formControlName="lockboxCheck" class="flexrow-padding" [disabled]="true">
            <mat-label class = "whitespace-normal">SSN Validation</mat-label>
          </mat-checkbox>

          <mat-checkbox formControlName="lockboxCheck" class="flexrow-padding" [disabled]="true">
            <mat-label class = "whitespace-normal">SSN Trace</mat-label>
          </mat-checkbox>

          <mat-checkbox formControlName="lockboxCheck" class="flexrow-padding" [disabled]="true">
            <mat-label class = "whitespace-normal">National Criminal Database</mat-label>
          </mat-checkbox>

          <mat-checkbox formControlName="lockboxCheck" class="flexrow-padding" [disabled]="true">
            <mat-label class = "whitespace-normal">County Criminal</mat-label>
          </mat-checkbox>

          <mat-checkbox formControlName="lockboxCheck" class="flexrow-padding" [disabled]="true">
            <mat-label class = "whitespace-normal">Federal Criminal</mat-label>
          </mat-checkbox>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space">
      <mat-card-content>
        <h3 class="bofa--heading is-5">Personal Information</h3>

        <div class = "flex-row-wrap">
          <mat-form-field class="vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>First Name</mat-label>
            <input matInput formControlName="firstName" maxlength="50">
            <mat-error>Please enter a valid First Name</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-field-width">
            <mat-label>Middle Name</mat-label>
            <input matInput formControlName="middleName" maxlength="50">
            <mat-error>Please enter a valid Middle Name</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Last Name</mat-label>
            <input matInput formControlName="lastName" maxlength="50">
            <mat-error>Please enter a valid Last Name</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-field-width">
            <mat-label>Suffix</mat-label>
            <input matInput formControlName="suffix" maxlength="10">
            <mat-error>Please enter a valid Suffix</mat-error>
          </mat-form-field>
        </div>

        <div class = "flex-row-wrap">
          <mat-form-field class="zoom-error-space vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Email Address</mat-label>
            <input matInput formControlName="email" maxlength="100">
            <mat-error>Please enter a valid Email Address so we may contact you with any background communications
            </mat-error>
          </mat-form-field>

          <mat-form-field class="max-zoom field-space vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Country</mat-label>
            <mat-select formControlName="country" required>
              <mat-option>Select</mat-option>
              <mat-option *ngFor="let countryLkp of vendorRequestData.countryLookup | keyvalue : valueAscOrder"
                [value]="countryLkp.key">
                {{countryLkp.value}}
              </mat-option>
            </mat-select>
            <mat-error>Please select Country</mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space">
      <mat-card-content>
        <h3 class="bofa--heading is-5">Job Details</h3>

        <div class = "flex-row-wrap">
          <mat-form-field class="max-zoom field-space vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Job Country</mat-label>
            <mat-select formControlName="jobCountry" required>
              <mat-option>Select</mat-option>
              <mat-option *ngFor="let country of vendorRequestData.countryLookup | keyvalue : valueAscOrder"
                [value]="country.key">
                {{country.value}}
              </mat-option>
            </mat-select>
            <mat-error>Please select Job Country</mat-error>
          </mat-form-field>

          <mat-form-field class="max-zoom field-space vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Account</mat-label>
            <mat-select formControlName="vendorAccount">
              <mat-option>Select</mat-option>
              <mat-option
                *ngFor="let account of vendorRequestData.vendorAccountMap | keyvalue : ascOrderVendorAccountFirst"
                [value]="account.key">
                {{account.value}}
              </mat-option>
            </mat-select>
            <mat-error>Please select Account</mat-error>
          </mat-form-field>
        </div>

        <div class = "flex-row-wrap">
          <mat-form-field class="vc-field-width">
            <mat-label>Vendor Name</mat-label>
            <input matInput formControlName="vendorName" maxlength="100">
            <mat-error>Please enter a valid Vendor Name</mat-error>
          </mat-form-field>

          

          <mat-form-field class="vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Reference Number</mat-label>
            <input matInput formControlName="refNum" maxlength="30">
            <mat-error>Please enter a valid Reference Number</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Company Code/Cost Center</mat-label>
            <input matInput formControlName="costCenter" maxlength="13">
            <mat-error>Please enter a valid Company Code/Cost Center</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-field-width" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Mail Code</mat-label>
            <input type="text" matInput formControlName="mailCode" />
            <mat-error role="alert" *ngIf="!vendorRequestForm.controls['mailCode']?.value?.length && vendorRequestForm.controls['mailCode']?.invalid">Please enter a Mail Code</mat-error>
            <mat-error role="alert" *ngIf="vendorRequestForm.controls['mailCode']?.value?.length > 0 && vendorRequestForm.controls['mailCode']?.invalid">Please enter a valid Mail Code Format (XXX-XXX-XX-XX)</mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </form>

  <div class="actions">
    <button type="button" (click)="onReset()" class="bofa--button secondary dark-blue large">Clear</button>
    <button type="button" (click)="onSubmit()"
      class="bofa--button primary large ui-font no-margin-right">Submit</button>
  </div>
</div>

<ng-template #loading>
  <div class="double-top-space">
    <p>Loading Vendor request form ...</p>
  </div>
</ng-template>
